import { render, staticRenderFns } from "./DirectoryTheme.vue?vue&type=template&id=2d54fc4c"
import script from "./DirectoryTheme.vue?vue&type=script&lang=js"
export * from "./DirectoryTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports